{once} = require 'underscore'

# groupon-deal-timer
require('../../../groupon-deal-timer/responsive/common/helpers')
require('../../../groupon-deal-timer/responsive/frontend/models/countdown_timer')
require('../../../groupon-deal-timer/responsive/frontend/views/countdown_timer')
require('../../../groupon-deal-timer/responsive/frontend/countdown_timer')

{attributeNames, classNames, selectors} = require './constants'
CircularProgressBar = require '../../../circular_progress_bar/frontend/views/circular_progress_bar'

module.exports = JuiceProgramView = Backbone.View.extend
  UPDATE_COUNTDOWN_MS: 1000
  CLEAN_VIEW_ANIMATION_MS: 2000
  el: "#{selectors.purchaseCluster}, #{selectors.multiOptionOverlay}"
  events:
    "click #{selectors.inlineOptionInput}": 'optionSelected'
    "click #{selectors.multiOptionOverlayInput}": 'optionSelected'
    "click #{selectors.viewMoreButton}": 'viewMoreButtonClicked'

  initialize: ->
    @juiceProgramEnded = not @model.timeLeft()
    @$el.addClass classNames.juiceProgramEnabled
    @overlayExists = @$(selectors.multiOptionOverlayInput).length > 0
    @progressBar = new CircularProgressBar
      el: selectors.bannerMessage

  render: ->
    clearInterval @_juiceTimer if @_juiceTimer?
    @_juiceTimer = setInterval (=> @updateJuiceCountdown()), @UPDATE_COUNTDOWN_MS
    this

  optionSelected: (e) ->
    @updateJuicePrices @$ e.currentTarget

  viewMoreButtonClicked: once ->
    # If view button is clicked before selecting another option,
    # regular price element in overlay probably is not added yet.
    # This is only needed for the very first click on view button.
    @updateJuicePrices @$(selectors.multiOptionOverlayInput).filter(':checked')

  updateJuicePrices: ($option) ->
    return if @juiceProgramEnded or not $option
    @$(selectors.extraDiscount)?.text $option.attr attributeNames.extraDiscount

  updateJuiceCountdown: ->
    if timeLeft = @model.timeLeft()
      @$(selectors.timerInBannerMessage)?.text timeLeft.textTime
      @progressBar.updateProgress timeLeft.progress, timeLeft.clockTime
      # Use same time format for countdown timer in deal highlights,
      # hence cancel the timer in deal highlights.
      @$('.countdown-timer').text timeLeft.clockTime
      if countDownTimer = CountdownTimer?.current?.timerView?.interval
        clearInterval countDownTimer
    else
      @juiceProgramEnded = true
      clearInterval @_juiceTimer
      @cleanJuiceUI()
      @undelegateEvents()

  cleanJuiceUI: ->
    @removeJuiceElements()
    @changeToOldPrices()
    @$el.addClass classNames.juiceProgramExpired
    @$el.removeClass classNames.juiceProgramEnabled

    @$(selectors.bannerMessage).animate
      'height': '0px'
      'opacity': 0
      'padding-top': '0px'
      'padding-bottom': '0px'
    , @CLEAN_VIEW_ANIMATION_MS, 'linear', =>
      @$(selectors.bannerMessage).remove()

  removeJuiceElements: ->
    juiceElements = [
      selectors.offerLabel
      selectors.discountBadge
      selectors.overlayClusterDiscount
    ]
    @$(juiceElements.join(', ')).remove()

  changeToOldPrices: ->
    @$('.breakout-option-price')
      .addClass 'c-txt-price'
      .removeClass 'urgency-pricing c-txt-err'

    # Change data attributes for each option
    attrsToRemove = [
      attributeNames.regularPrice
      attributeNames.extraDiscount
      attributeNames.discountPercentage
      attributeNames.offerLabel
    ].join ' '
    for element in @$ "#{selectors.inlineOptionInput}, #{selectors.multiOptionOverlayInput}"
      $input = @$ element
      regularPrice = $input.attr attributeNames.regularPrice
      $input
        .removeAttr attrsToRemove
        .attr attributeNames.price, regularPrice
      priceLabel = $input.next('label')?.find '.breakout-option-price'
      priceLabel.text regularPrice

    # Update price in overlay cluster
    if @overlayExists
      price = @$(selectors.multiOptionOverlayInput).filter(':checked')?.attr attributeNames.price
      @$ selectors.overlayClusterPrice
        .text price
        .addClass 'c-txt-price'
        .removeClass 'tooltip-trigger urgency-pricing'
